module.exports = __webpack_public_path__ + "static/fonts/3e18b964-7a6f-4828-8e18-5cc698e1051f.c99c69c.woff";